import { Directive, ElementRef, Input, OnInit } from '@angular/core';

// taken from here: https://stackoverflow.com/questions/50006888/set-focus-on-input-element
@Directive({
  selector: '[appFocusAndSelect]',
})
export class FocusAndSelectDirective implements OnInit {
  @Input() focusAndSelectCondition: boolean;

  constructor(private el: ElementRef) {
    if (!el.nativeElement['focus']) {
      throw new Error('Element does not accept focus.');
    }
  }

  ngOnInit(): void {
    if (this.focusAndSelectCondition) {
      (async () => {
        //Delay used to mitigate opening of modal animation
        await this.delay(30);

        const input: HTMLInputElement = this.el
          .nativeElement as HTMLInputElement;
        input.focus();
        input.select();
      })();
    }
  }

  private delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
